if (!customElements.get('cart-drawer-info-slider')) {
  class CartDrawerInfoSlider extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', () => {
          this.init();
        });
      }

      this.init();
    }

    init() {

      const infoSwiper = document.querySelector('.cart-drawer__swiper');

      if (infoSwiper) {
        new Swiper(infoSwiper, {
          direction: 'vertical',
          slidesPerView: 1,
          loop: true,
          allowTouchMove: false,
          autoplay: {
            delay: 5000,
          }
        });
      }

      const trustSwiper = document.querySelector('.cart-trust-swiper');

      if (trustSwiper) {
        new Swiper(trustSwiper, {
          direction: 'vertical',
          slidesPerView: 1,
          loop: true,
          allowTouchMove: false,
          autoplay: {
            delay: 3500,
          }
        });
      }
    }
  }

  customElements.define('cart-drawer-info-slider', CartDrawerInfoSlider);
}